const PLAID_VERIFICATION_STATUS = {
  PENDING_MANUAL_VERIFICATION: 'pending_manual_verification',
  MANUALLY_VERIFIED: 'manually_verified',
  VERIFICATION_EXPIRED: 'verification_expired',
};

export default PLAID_VERIFICATION_STATUS;
